// Released dispatcher-alerts v1 registry. Detection is server-authoritative:
// never reconstruct native status/count/threshold rules from active-list snapshots.
export const CHIMES = [
  { id: 'bell', label: 'Bell', notes: [880, 1320] },
  { id: 'pulse', label: 'Pulse', notes: [660, 660, 660] },
  { id: 'fall', label: 'Descending', notes: [880, 660, 440] },
  { id: 'rise', label: 'Ascending', notes: [523, 659, 784] },
];

const activity = (e) => e.kind === 'activity';
const exception = (e) => e.kind === 'exception_created';
export const SOUND_EVENTS = [
  { id: 'doordash_exception', label: 'DoorDash exception', defaultChime: 'bell',
    detect: exception },
  { id: 'driver_rejection', label: 'Driver rejection', defaultChime: 'pulse',
    detect: activity },
  { id: 'en_route_and_unassigned', label: 'En route — next assignment', defaultChime: 'fall',
    detect: activity },
  { id: 'new_delivery_order', label: 'New delivery order', defaultChime: 'rise',
    detect: activity },
  { id: 'new_driver_message', label: 'New driver message', defaultChime: 'rise', detect: activity },
  { id: 'need_driver', label: 'Needs driver', defaultChime: 'bell', detect: exception },
  { id: 'not_accepted', label: 'Driver has not accepted', defaultChime: 'pulse', detect: exception },
  { id: 'not_confirmed', label: 'Restaurant has not confirmed', defaultChime: 'pulse', detect: exception },
  { id: 'late_arrival', label: 'Late restaurant arrival', defaultChime: 'bell', detect: exception },
  { id: 'late_pick_up', label: 'Late pickup', defaultChime: 'bell', detect: exception },
  { id: 'late_drop_off', label: 'Late drop-off', defaultChime: 'bell', detect: exception },
];

export const defaultPreferences = () => ({
  version: 1, masterEnabled: false, volume: 0.5,
  events: Object.fromEntries(SOUND_EVENTS.map((e) =>
    [e.id, { enabled: true, chime: e.defaultChime }])),
});

const object = (value) => value && typeof value === 'object' && !Array.isArray(value);
export function validatePreferences(value) {
  if (!object(value) || value.version !== 1 || typeof value.masterEnabled !== 'boolean' ||
      !Number.isFinite(value.volume) || value.volume < 0 || value.volume > 1 ||
      !object(value.events)) throw new Error('Invalid sound preferences');
  if (Object.keys(value.events).length > 64 ||
      encodeURIComponent(JSON.stringify(value)).replace(/%[A-F\d]{2}/g, 'x').length > 16384) {
    throw new Error('Sound preferences exceed supported limits');
  }
  const defaults = defaultPreferences();
  const events = { ...value.events };
  SOUND_EVENTS.forEach(({ id }) => {
    const entry = events[id] === undefined ? defaults.events[id] : events[id];
    if (!object(entry) || typeof entry.enabled !== 'boolean' ||
        !CHIMES.some((c) => c.id === entry.chime)) throw new Error('Invalid sound preferences');
    events[id] = { ...entry };
  });
  // Preserve unknown top-level, event and per-event keys for forward compatibility.
  return { ...value, events };
}

export function mergePreferences(value, patch) {
  const events = { ...value.events };
  Object.entries(patch.events || {}).forEach(([id, entry]) => {
    events[id] = { ...events[id], ...entry };
  });
  return validatePreferences({ ...value, ...patch, events });
}
